<app-loading class="full-screen" *ngIf="response.processing; else notProcessing"></app-loading>
<ng-template #notProcessing>
  <div class="main-wrapper">
    <div class="auth-sidebar">
      <div class="header">
        <a [routerLink]="session_info?.last_routes.new_home || '/'">
          <img loading="lazy" src="assets/logos/logo.png" height="30" class="mb-4">
        </a>
        <h3>QR code-accessible web pages for all use cases</h3>
      </div>
    </div>
    <div class="auth-contents">
      <div class="form-contents">

        <ng-container *ngIf="!error; else errorOccurred">
          <div class="form-header">
            <a [routerLink]="session_info?.last_routes.new_home || '/'" class="d-lg-none">
              <img loading="lazy" src="assets/logos/logo.png" height="30" class="mb-4">
            </a>
            <h2>Invitation to join</h2>
            <p class="lg">{{response.team_name}}</p>
          </div>
          <form #signUpForm="ngForm" (ngSubmit)="joinTeam()" [formGroup]="signupform">
            <div class="mt-4">
              <div class="mb-3">
                <label class="form-label bold">Name<span class="text-danger">*</span></label>
                <input type="text" formControlName="name" required class="form-control"
                  [class.is-invalid]="signupform.get('name').hasError('required') && signupform.get('name').touched"
                  placeholder="Please type your full name">
                <p class="input-error"
                  *ngIf="signupform.get('name').hasError('required') && signupform.get('name').touched">
                  Full name is required!</p>
              </div>
              <div class="mb-3">
                <label class="form-label bold">Password<span class="text-danger">*</span></label>
                <input type="password" formControlName="password" required class="form-control" minlength="6"
                  [class.is-invalid]="signupform.get('password').hasError('required') && signupform.get('password').touched"
                  placeholder="Password">
                <ng-container *ngIf="signupform.get('password').touched">
                  <p class="input-error" *ngIf="signupform.get('password').hasError('required')">
                    Password is required!</p>
                  <p class="input-error" *ngIf="signupform.get('password').hasError('minlength')">
                    Password strength is weak!</p>
                </ng-container>
              </div>
              <button type="submit" class="btn btn-secondary btn-block mt-5" [disabled]="processing">
                <app-inline-loader *ngIf="processing"></app-inline-loader>
                <span *ngIf="!processing">Join</span>
              </button>
            </div>
          </form>
        </ng-container>
        <ng-template #errorOccurred>
          <div class="text-center">
            <div class="form-header mb-4">
              <a [routerLink]="session_info?.last_routes.new_home || '/'" class="d-lg-none">
                <img loading="lazy" src="assets/logos/logo.png" height="30" class="mb-4">
              </a>
            </div>
            <img loading="lazy" src="assets/error.png" width="50%" class="mb-5">
            <h5>{{error}}</h5>
            <button routerLink="/auth/signup" class="btn btn-secondary btn-block mt-5">Create a
              personal
              account</button>
          </div>
        </ng-template>

      </div>
    </div>
  </div>
</ng-template>